import { render, staticRenderFns } from "./goods_detail.vue?vue&type=template&id=cd49af70&scoped=true&"
import script from "./goods_detail.vue?vue&type=script&lang=js&"
export * from "./goods_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd49af70",
  null
  
)

export default component.exports